enum METRIC {
  AppTotalUserEvents = 'app_total_user_events',
}

export default METRIC;
